import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Login from '@/views/pages/Login'
import Page404 from '@/views/pages/Page404'

import AccessPrivilege from '@/views/accessPrivilege/AccessPrivilege'

import Draw from '@/views/luckywheel/draw/Draw'
import DrawList from '@/views/luckywheel/drawlist/DrawList'
import Gift from '@/views/luckywheel/gift/Gift'
import GiftList from '@/views/luckywheel/giftlist/GiftList'
import Ticket from '@/views/luckywheel/ticket/Ticket'
import Rule from '@/views/luckywheel/rule/Rule'
import RuleList from '@/views/luckywheel/rulelist/RuleList'
import Domain from '@/views/luckywheel/domain/Domain'
import MemberLevel from '@/views/jeetPrivilege/memberLevel/MemberLevel'
import MonthlyTierBonus from '@/views/jeetPrivilege/vipProgram/MonthlyTierBonus'

import CashbackReport from '@/views/jeetPrivilege/cashback/cashbackReport/CashbackReport'
import CashbackSpecialMember from '@/views/jeetPrivilege/cashback/specialMember/SpecialMember'
import SportsReport from '@/views/jeetPrivilege/cashback/sportsReport/SportsReport'
import EarlyCashback from '@/views/jeetPrivilege/cashback/earlyCashback/EarlyCashback'
import CashbackJobLog from '@/views/jeetPrivilege/cashback/cashbackJobLog/CashbackJobLog'

import WithdrawWhitelist from '@/views/payment/withdraw/Whitelist'
import LoyaltyPointReddemRequest from '@/views/payment/loyaltypoint/RedeemRequest'
import VIPLevelMember from '@/views/payment/viplevel/VIPLevelMember'
import VIPLevelAccount from '@/views/payment/viplevel/VIPLevelAccount'
import VIPLevelSettings from '@/views/payment/viplevel/VIPLevelSettings'
import VIPLevelPayment from '@/views/payment/viplevel/VIPLevelPayment'
import VIPLevelBankAccount from '@/views/payment/viplevel/VIPLevelBankAccount'

import SCSettings from '@/views/scratchcard/settings/Setting'
import SCRewards from '@/views/scratchcard/rewards/Rewards'
import SCTickets from '@/views/scratchcard/tickets/Tickets'

import LTSettings from '@/views/lottery/settings/Settings'
import LTDraw from '@/views/lottery/draw/Draw'
import LTTickets from '@/views/lottery/tickets/Tickets'

import WithdrawVIPLevelSettings from '@/views/payment/viplevelwithdraw/viplevelsettings/VIPLevelSettings'
import WithdrawVIPLevelMember from '@/views/payment/viplevelwithdraw/viplevelmember/VIPLevelMember'
import WithdrawVIPLevelPayment from '@/views/payment/viplevelwithdraw/viplevelpayment/VIPLevelPayment'

import ReferralBonus from '@/views/promotion/referral/Referral'
import ReferralCommission from '@/views/promotion/referralCommission/ReferralCommission'
import LoyaltyReward from '@/views/promotion/loyaltyreward/LoyaltyReward'
import PromoCode from '@/views/promotion/promoCode/PromoCode'

import MainTournament from '@/views/tournament/MainTournament'
import QuickTournament from '@/views/tournament/QuickTournament'
import ManualDeposit from '@/views/manualDeposit/ManualDeposit'
import Poster from '@/views/poster/Poster'

import GamePlatforms from '@/views/game/platforms/Platform'
import GameImages from '@/views/game/images/Images'
import GameThumbnails from '@/views/game/thumbnails/Thumbnails'

import VIPLevelSettingActivityLog from '@/views/activityLog/payment/viplevel/VIPLevelSettings'
import VIPLevelMemberActivityLog from '@/views/activityLog/payment/viplevel/VIPLevelMember'
import VIPLevelAccountActivityLog from '@/views/activityLog/payment/viplevel/VIPLevelAccount'
import VIPLevelPaymentActivityLog from '@/views/activityLog/payment/viplevel/VIPLevelPayment'

import VIPLevelWithdrawMemberActivityLog from '@/views/activityLog/payment/withdraw/VIPLevelMember'
import VIPLevelWithdrawMethodActivityLog from '@/views/activityLog/payment/withdraw/VIPLevelMethod'

import WithdrawRecords from '@/views/payment/records/withdraw/WithdrawRecords.vue'
import MemberBankIFSC from '@/views/payment/records/memberBankIFSC/MemberBankIFSC.vue'
import ICICIPayout from '@/views/payment/records/ICICIPayout/ICICIPayout.vue'

import PNLReport from '@/views/report/payment/PNLReport'
import DailyDepositReport from '@/views/report/payment/DailyDeposit'
import MemberBankReport from '@/views/report/member/MemberBankReport'
import DailySignupMemberReport from '@/views/report/member/DailySignupMemberReport'
import InactiveMemberReport from '@/views/report/member/InactiveMemberReport'
import DailyReportDetail from '@/views/report/member/DailyReportDetail'

import LuckyWheelReport from '@/views/report/mini-games/luckywheel/LuckyWheelReport'
import ScratchCardReport from '@/views/report/mini-games/scratchcard/ScratchCardReport'
import LotteryReport from '@/views/report/mini-games/lottery/LotteryReport'

import PromotionJoinReport from '@/views/report/promotion/promotionJoin/PromotionJoinReport'
import PromoCodeReport from '@/views/report/promotion/promoCode/PromoCodeReport'

import DailySignupAnalysis from '@/views/report/risk/DailySignupAnalysis'
import DailyFirstDepositAnalysis from '@/views/report/risk/DailyFirstDepositAnalysis'
import HighTurnoverReport from '@/views/report/risk/promotion/HighTurnoverReport'
import HighPayoutReport from '@/views/report/risk/game/HighPayoutReport'
import AbnormalBetReport from '@/views/report/risk/game/AbnormalBetReport'
import GameTrendReport from '@/views/report/risk/game/GameTrendReport'

import CDNFileManager from '@/views/cdnFileManager/CDNFileManager'
import SystemConfig from '@/views/systemConfig/SystemConfig'

import ReceiptAccount from '@/views/payment/bank/ReceiptAccount'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'access-privilege',
          name: 'Access Privilege',
          meta: {
            module: 'System.AccessLimit'
          },
          component: AccessPrivilege
        },
        {
          path: 'cdn-image-manager',
          name: 'CDN Image Manager',
          meta: {
            module: 'System.CDNFileManager'
          },
          component: CDNFileManager
        },
        {
          path: 'system-config',
          name: 'System Config',
          meta: {
            module: 'System.Config'
          },
          component: SystemConfig
        },
        {
          path: 'member-privilege',
          redirect: '/member-privilege/member-level',
          name: 'Member Privilege',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'member-level',
              name: 'Member Level',
              meta: {
                module: 'JeetPrivilege.MemberLevel'
              },
              component: MemberLevel
            },
            {
              path: 'vip-program',
              name: 'Monthly Tier Bonus',
              meta: {
                module: 'JeetPrivilege.VipProgram'
              },
              component: MonthlyTierBonus
            },
            {
              path: 'cashback',
              name: 'Cashback',
              redirect: '/member-privilege/cashback/report',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'report',
                  name: 'Cashback Report',
                  meta: {
                    module: 'JeetPrivilege.Cashback.Report'
                  },
                  component: CashbackReport
                },
                {
                  path: 'sportsReport',
                  name: 'Sports Cashback Report',
                  meta: {
                    module: 'JeetPrivilege.SportsCashback'
                  },
                  component: SportsReport
                },
                {
                  path: 'earlyCashback',
                  name: 'Early Cashback List',
                  meta: {
                    module: 'JeetPrivilege.Cashback.EarlyCashback'
                  },
                  component: EarlyCashback
                },
                {
                  path: 'cashbackjoblog',
                  name: 'Cashback Job Log',
                  meta: {
                    module: 'JeetPrivilege.Cashback.BotLog'
                  },
                  component: CashbackJobLog
                },
                {
                  path: 'special-member',
                  name: 'Special Member Rate',
                  meta: {
                    module: 'JeetPrivilege.Cashback.SpecialMember'
                  },
                  component: CashbackSpecialMember
                }
              ]
            }
          ]
        },
        {
          path: 'payment',
          name: 'Payment',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'manualDeposit',
              name: 'ManualDeposit',
              meta: {
                module: 'Payment.ManualDeposit'
              },
              component: ManualDeposit
            },
            {
              path: 'bank',
              name: 'Bank',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'receiptAccount',
                  name: 'Receipt Account',
                  meta: {
                    module: 'Payment.Bank.ReceiptAccount'
                  },
                  component: ReceiptAccount
                }
              ]
            },
            {
              path: 'records',
              name: 'Records',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'withdraw',
                  name: 'Withdraw Records',
                  meta: {
                    module: 'Payment.Records.Withdraw'
                  },
                  component: WithdrawRecords
                },
                {
                  path: 'memberBankIFSC',
                  name: 'Member Bank IFSC',
                  meta: {
                    module: 'Payment.Records.MemberBankIFSC'
                  },
                  component: MemberBankIFSC
                },
                {
                  path: 'ICICIPayout',
                  name: 'ICICI Payout Withdraw Detail',
                  meta: {
                    module: 'Payment.Records.ICICI.Payout'
                  },
                  component: ICICIPayout
                }
              ]
            },
            {
              path: 'whitelist',
              name: 'Whitelist',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'withdraw-whitelist',
                  name: 'Withdraw Whitelist',
                  meta: {
                    module: 'Payment.Whitelist.Withdraw'
                  },
                  component: WithdrawWhitelist
                }
              ]
            },
            {
              path: 'viplevel',
              name: 'VIP Level',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'viplevel-member',
                  name: 'Member',
                  meta: {
                    module: 'Payment.Level.Member'
                  },
                  component: VIPLevelMember
                },
                {
                  path: 'viplevel-account',
                  name: 'Account',
                  meta: {
                    module: 'Payment.Level.Account'
                  },
                  component: VIPLevelAccount
                },
                {
                  path: 'viplevel-settings',
                  name: 'Settings',
                  meta: {
                    module: 'Payment.Level.Settings'
                  },
                  component: VIPLevelSettings
                },
                {
                  path: 'viplevel-payment',
                  name: 'Payment Option',
                  meta: {
                    module: 'Payment.Level.Options'
                  },
                  component: VIPLevelPayment
                },
                {
                  path: 'viplevel-bank',
                  name: 'Bank Account Settings',
                  meta: {
                    module: 'Payment.Level.BankMaintenance'
                  },
                  component: VIPLevelBankAccount
                }
              ]
            },
            {
              path: 'withdraw',
              name: 'VIP Withdraw',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'viplevel',
                  name: 'VIP Levels (Withdraw)',
                  component: {
                    render (c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'viplevel-settings',
                      name: 'Settings (Withdraw)',
                      meta: {
                        module: 'Payment.WithdrawViplevel.LevelSettings'
                      },
                      component: WithdrawVIPLevelSettings
                    },
                    {
                      path: 'viplevel-member',
                      name: 'Member (Withdraw)',
                      meta: {
                        module: 'Payment.WithdrawViplevel.Member'
                      },
                      component: WithdrawVIPLevelMember
                    },
                    {
                      path: 'viplevel-payment',
                      name: 'Payment (Withdraw)',
                      meta: {
                        module: 'Payment.WithdrawViplevel.Method'
                      },
                      component: WithdrawVIPLevelPayment
                    }
                  ]
                }
              ]
            },
            {
              path: 'lp-redeem-request',
              name: 'Loyalty Point Redeem Request',
              meta: {
                module: 'Payment.LoyaltyRedeem.Request'
              },
              component: LoyaltyPointReddemRequest
            }
          ]
        },
        {
          path: 'promotion',
          name: 'Promotion',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'referral',
              name: 'Referral Bonus List',
              meta: {
                module: 'Promotion.Referral'
              },
              component: ReferralBonus
            },
            {
              path: 'referral-commission',
              name: 'Referral Commission Records',
              meta: {
                module: 'Promotion.ReferralCommission'
              },
              component: ReferralCommission
            },
            {
              path: 'loyaltyreward',
              name: '2x Reward Bonus List',
              meta: {
                module: 'Promotion.RewardBonus'
              },
              component: LoyaltyReward
            },
            {
              path: 'promocode',
              name: 'Promo Code',
              meta: {
                module: 'Promotion.PromoCode'
              },
              component: PromoCode
            }
          ]
        },
        {
          path: 'activity-log',
          name: 'Activity Log',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'payment',
              name: 'Payment Logs',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'viplevel',
                  name: 'Vip Level Logs',
                  component: {
                    render (c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'settings',
                      name: 'Settings Logs',
                      meta: {
                        module: 'RL.Logs.Payment.Viplevel.LevelSettings'
                      },
                      component: VIPLevelSettingActivityLog
                    },
                    {
                      path: 'member',
                      name: 'Member Logs',
                      meta: {
                        module: 'RL.Logs.Payment.Viplevel.LevelMember'
                      },
                      component: VIPLevelMemberActivityLog
                    },
                    {
                      path: 'account',
                      name: 'Account Logs',
                      meta: {
                        module: 'RL.Logs.Payment.Viplevel.LevelAccount'
                      },
                      component: VIPLevelAccountActivityLog
                    },
                    {
                      path: 'payment',
                      name: 'Payment Options Logs',
                      meta: {
                        module: 'RL.Logs.Payment.Viplevel.LevelOptions'
                      },
                      component: VIPLevelPaymentActivityLog
                    }
                  ]
                },
                {
                  path: 'withdraw',
                  name: 'Vip level Withdraw logs',
                  component: {
                    render (c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'member',
                      name: 'Withdraw Member logs',
                      meta: {
                        module: 'RL.Logs.Payment.WithdrawViplevel.Member'
                      },
                      component: VIPLevelWithdrawMemberActivityLog
                    },
                    {
                      path: 'method',
                      name: 'Withdraw Method logs',
                      meta: {
                        module: 'RL.Logs.Payment.WithdrawViplevel.Method'
                      },
                      component: VIPLevelWithdrawMethodActivityLog
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'tournament',
          name: 'Tournament',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'main',
              name: 'Main',
              meta: {
                module: 'CMS.Tournament.Main'
              },
              component: MainTournament
            },
            {
              path: 'quick',
              name: 'Quick',
              meta: {
                module: 'CMS.Tournament.Quick'
              },
              component: QuickTournament
            }
          ]
        },
        {
          path: 'poster-ad',
          name: 'Poster Ad',
          meta: {
            module: 'CMS.Poster'
          },
          component: Poster
        },
        {
          path: 'game-platforms',
          name: 'Game Platforms',
          meta: {
            module: 'CMS.GamePlatforms'
          },
          component: GamePlatforms
        },
        {
          path: 'game-images',
          name: 'Game Images',
          meta: {
            module: 'CMS.GameImages'
          },
          component: GameImages
        },
        {
          path: 'game-thumbnails',
          name: 'Game Thumbnails',
          meta: {
            module: 'CMS.GameThumbnails'
          },
          component: GameThumbnails
        },
        {
          path: 'report',
          name: 'Report',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'payment',
              name: 'Payment Report',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'pnl',
                  name: 'PNL',
                  meta: {
                    module: 'RL.Report.PNL'
                  },
                  component: PNLReport
                },
                {
                  path: 'dailyDeposit',
                  name: 'Daily Deposit',
                  meta: {
                    module: ''
                  },
                  component: DailyDepositReport
                }
              ]
            },
            {
              path: 'mini-games',
              name: 'Mini Games',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'luckywheel',
                  name: 'Lucky Wheel',
                  meta: {
                    module: 'RL.Report.MiniGames.LuckyWheel'
                  },
                  component: LuckyWheelReport
                },
                {
                  path: 'scratchcard',
                  name: 'Scratch Card',
                  meta: {
                    module: 'RL.Report.MiniGames.ScratchCard'
                  },
                  component: ScratchCardReport
                },
                {
                  path: 'lottery',
                  name: 'Lottery',
                  meta: {
                    module: 'RL.Report.MiniGames.Lottery'
                  },
                  component: LotteryReport
                }
              ]
            },
            {
              path: 'promotion',
              name: 'Promotion',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'join',
                  name: 'Promotion Join',
                  meta: {
                    module: 'RL.Report.Promotion.Join'
                  },
                  component: PromotionJoinReport
                },
                {
                  path: 'promo-code',
                  name: 'Promo Code',
                  meta: {
                    module: 'RL.Report.Promotion.PromoCode'
                  },
                  component: PromoCodeReport
                }
              ]
            },
            {
              path: 'member',
              name: 'Member Report',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'memberBank',
                  name: 'Bank Detail',
                  meta: {
                    module: 'RL.Report.MemberBank'
                  },
                  component: MemberBankReport
                },
                {
                  path: 'inactiveMember',
                  name: 'Inactive Member',
                  meta: {
                    module: 'RL.Report.InactiveMember'
                  },
                  component: InactiveMemberReport
                },
                {
                  path: 'dailySignup',
                  name: 'Daily Signup',
                  meta: {
                    module: 'RL.Report.DailySignup'
                  },
                  component: DailySignupMemberReport
                },
                {
                  path: 'dailyReport',
                  name: 'Daily Report',
                  meta: {
                    module: 'RL.Report.DailyReport'
                  },
                  component: DailyReportDetail
                },
                {
                  path: 'riskAnalysis',
                  name: 'Risk Analysis',
                  component: {
                    render (c) {
                      return c('router-view')
                    }
                  },
                  children: [
                    {
                      path: 'dailySignup',
                      name: 'Daily Signup',
                      meta: {
                        module: 'RL.Report.RiskAnalysis.DailySignup'
                      },
                      component: DailySignupAnalysis
                    },
                    {
                      path: 'dailyFirstDeposit',
                      name: 'Daily First Deposit',
                      meta: {
                        module: 'RL.Report.RiskAnalysis.DailySignup'
                      },
                      component: DailyFirstDepositAnalysis
                    },
                    {
                      path: 'highTurnover',
                      name: 'High Turnover Games',
                      meta: {
                        module: 'RL.Report.RiskAnalysis.HighTurnover'
                      },
                      component: HighTurnoverReport
                    },
                    {
                      path: 'highPayout',
                      name: 'High Payout Games',
                      meta: {
                        module: 'RL.Report.RiskAnalysis.HighPayout'
                      },
                      component: HighPayoutReport
                    },
                    {
                      path: 'abnormalBet',
                      name: 'High Abnormal Bet',
                      meta: {
                        module: 'RL.Report.RiskAnalysis.AbnormalBet'
                      },
                      component: AbnormalBetReport
                    },
                    {
                      path: 'gameTrend',
                      name: 'Game Trend',
                      meta: {
                        module: 'RL.Report.RiskAnalysis.GameTrend'
                      },
                      component: GameTrendReport
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: 'scratch-card',
          redirect: '/scratchcard/ticket',
          name: 'ScratchCard',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'settings',
              name: 'Settings',
              meta: {
                module: 'ScratchCard.Settings'
              },
              component: SCSettings
            },
            {
              path: 'rewards',
              name: 'Rewards',
              meta: {
                module: 'ScratchCard.Rewards'
              },
              component: SCRewards
            },
            {
              path: 'tickets',
              name: 'Tickets',
              meta: {
                module: 'ScratchCard.Tickets'
              },
              component: SCTickets
            }
          ]
        },
        {
          path: 'lottery',
          redirect: '/lottery/ticket',
          name: 'Lottery',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'settings',
              name: 'Settings',
              meta: {
                module: 'Lottery.Settings'
              },
              component: LTSettings
            },
            {
              path: 'draw',
              name: 'Draw',
              meta: {
                module: 'Lottery.Draw'
              },
              component: LTDraw
            },
            {
              path: 'tickets',
              name: 'Tickets',
              meta: {
                module: 'Lottery.Tickets'
              },
              component: LTTickets
            }
          ]
        },
        {
          path: 'lucky-wheel',
          redirect: '/lucky-wheel/ticket',
          name: 'Luck Wheel',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'domain',
              name: 'Domain',
              meta: {
                module: 'LuckyDraw.Domain'
              },
              component: Domain
            },
            {
              path: 'ticket',
              name: 'Ticket',
              meta: {
                module: 'LuckyDraw.Ticket'
              },
              component: Ticket
            },
            {
              path: 'draw',
              name: 'Draw',
              meta: {
                module: 'LuckyDraw.Draw'
              },
              component: Draw
            },
            {
              path: 'draw-list',
              name: 'Draw List',
              meta: {
                module: 'LuckyDraw.DrawList'
              },
              component: DrawList
            },
            {
              path: 'gift',
              name: 'Gift',
              meta: {
                module: 'LuckyDraw.Gift'
              },
              component: Gift
            },
            {
              path: 'gift-list',
              name: 'Gift List',
              meta: {
                module: 'LuckyDraw.GiftList'
              },
              component: GiftList
            },
            {
              path: 'rule',
              name: 'Rule',
              meta: {
                module: 'LuckyDraw.Rule'
              },
              component: Rule
            },
            {
              path: 'rule-list',
              name: 'Rule List',
              meta: {
                module: 'LuckyDraw.RuleList'
              },
              component: RuleList
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      name: 'Page404',
      component: Page404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js